import { defineComponent as _defineComponent } from 'vue'
import { shiftApi } from '@/api';
import Button from '@/components/buttons/Button.vue';
import Dialog from '@/components/dialog/Dialog.vue';
import InputGroup from '@/components/form/InputGroup.vue';
import NumberInput from '@/components/inputs/NumberInput.vue';
import LoadingOverlay from '@/components/loaders/LoadingOverlay.vue';
import i18n from '@/i18n';
import { useOpen } from '@/lib/composition/dialog';
import { Icon } from '@/lib/enum/Icon';
import { shiftMaxQuantity } from '@/lib/forms/customValidators/duplicateShifts';
import { showSuccess } from '@/plugins/ToastNotifications';
import { getErrorMessages, minValue, required } from '@/plugins/vuelidate';
import { viewport } from '@/util/windowFunctions';
import ShiftSummary from '@/views/schedule/components/ShiftSummary.vue';
import useVuelidate from '@vuelidate/core';
import { reactive, ref } from 'vue';
import { Shift } from '../../../../api/v1';
import ShiftDialogHeader from './components/ShiftDialogHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DuplicateShift',
  props: {
    value: { type: Boolean },
    shift: null
  },
  emits: ["input", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input'): void;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  shift: Shift;
}





const loading = ref(false);

const form = reactive<{ quantity: number }>({
  quantity: 1,
});
const validations = {
  quantity: {
    required,
    minValue: minValue(1),
    shiftMaxQuantity: shiftMaxQuantity(50),
  },
};
const v$ = useVuelidate(validations, form, { $autoDirty: true });

const open = useOpen(() => props.value, emit);

const duplicateShift = async () => {
  loading.value = true;
  const {
    employeeId,
    scheduleId,
    locationId,
    jobRoleId,
    open: shiftIsOpen,
    requiresApproval,
    startsAt,
    endsAt,
    showEndTime,
    showJobRole,
    tagIds,
    scheduledBreaks,
    shiftAreaSessions,
    notes,
  } = props.shift;

  try {
    await shiftApi.bulkCreateShifts({
      bulkCreateShiftData: {
        baseShiftData: {
          scheduleId,
          locationId,
          employeeId,
          jobRoleId,
          open: shiftIsOpen,
          requiresApproval,
          startsAt,
          endsAt,
          showEndTime,
          tagIds,
          scheduledBreaks,
          shiftAreaSessions,
          notes,
          showJobRole,
        },
        shifts: Array.from(Array(form.quantity), () => ({ employeeId })),
      },
    });
    showSuccess(
      i18n.tc('successMessage.createdDuplicateShifts', form.quantity),
    );
    open.value = false;
  } finally {
    loading.value = false;
  }
};

return { __sfc: true,props, emit, loading, form, validations, v$, open, duplicateShift, Button, Dialog, InputGroup, NumberInput, LoadingOverlay, Icon, getErrorMessages, viewport, ShiftSummary, ShiftDialogHeader }
}

})